// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.Tlp0px6kTB.Tlp0px6kTB {
  text-transform: none;
  margin: 0;
  padding-left: 0;
  letter-spacing: normal;
}
button.Tlp0px6kTB.Tlp0px6kTB:hover,
button.Tlp0px6kTB.Tlp0px6kTB:focus,
button.Tlp0px6kTB.Tlp0px6kTB:active {
  background: inherit;
  color: inherit;
}
.Rax_unRB6n.Rax_unRB6n {
  background-color: #e5e5e5;
  height: 32px;
  flex: 1;
  max-height: none;
  margin: 0;
  padding: 4px;
}
.Oi_IqLOa4p {
  max-width: 50px;
}
.Oi_IqLOa4p input {
  text-align: center;
}
.sQRIDGaYUj label {
  font-size: 12px;
}
.TuQPSMR4el {
  margin-bottom: 10px;
}
.w4IDiatebp label {
  line-height: normal;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.w4IDiatebp label input {
  margin-bottom: 0;
}
.w4IDiatebp + .w4IDiatebp {
  margin-top: 10px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"advanced-settings__textButtonRoot": `Tlp0px6kTB`,
	"advanced-settings__inputAdornmentRoot": `Rax_unRB6n`,
	"advanced-settings__maxRoundsRoot": `Oi_IqLOa4p`,
	"advanced-settings-section__innerCtn": `sQRIDGaYUj`,
	"advanced-settings__pulseSelectBaseRoot": `TuQPSMR4el`,
	"advanced-settings-section__root": `w4IDiatebp`
};
export default ___CSS_LOADER_EXPORT___;
